export default __webpack_public_path__ + "static/firstSec-4e7406add09aa04e380f3d85cbe48cdd.png";